import { useState } from "react";
import { t } from '../locales/translate.js';
function Element({ apiCall, user, setCookie }) {


  const [name, setName] = useState(user.name || "");
  const [email, setEmail] = useState(user.email || "");
  //phone
  const [phone, setPhone] = useState(user.phone || "");
  //'bank_account' => 'nullable|string|max:255',
  const [bankAccount, setBankAccount] = useState(user.bank_account || "");
  // 'bank_account_name' => 'nullable|string|max:255',
  const [bankAccountName, setBankAccountName] = useState(user.bank_account_name || "");
  // 'vat_applicable' => 'nullable|boolean' (Momsad)
  const [vatApplicable, setVatApplicable] = useState(!!user.vat_applicable);
  // 'organisationsnummer' => 'nullable|string', 10 digits (Org/Personnummer)
  const [organisationsnummer, setOrganisationsnummer] = useState(user.organisationsnummer || "");
  // 'interested_in_meat_return' => 'nullable|boolean',
  const [interestedInMeatReturn, setInterestedInMeatReturn] = useState(user.interested_in_meat_return || false);
  // 'password' => 'nullable|string|min:8',
  const [password, setPassword] = useState("");
  // password repeat
  const [passwordRepeat, setPasswordRepeat] = useState("");
  //update password switch
  const [updatePassword, setUpdatePassword] = useState(false);
  //emails
  const [emails, setEmails] = useState(user.invoice_emails || []);

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    const data = {
      name,
      email,
      phone,
      bank_account: bankAccount,
      bank_account_name: bankAccountName,
      interested_in_meat_return: interestedInMeatReturn,
      invoice_emails: emails,
      vat_applicable: vatApplicable,
    };

    if (vatApplicable) {
      // organisationsnummer: 10 digits after stripping non-digits (mirrors server)
      const orgnrDigits = organisationsnummer.replace(/\D/g, "");
      if (orgnrDigits.length !== 10) {
        setError(t('organisationsnummer_invalid_format'));
        return;
      }
      data.organisationsnummer = organisationsnummer;
    }

    if (updatePassword) {
      if (!password || !passwordRepeat) {
        setError(t('password_and_repeat_required'));
        return;
      }
      if (password !== passwordRepeat) {
        setError(t('passwords_do_not_match'));
        return;
      }
      data.password = password;
    }

    apiCall("PUT", `user/${user.id}`, data)
      .then(({ response, error }) => {
        if (error) {
          console.error(response);
          setError(error);
          return;
        }

        console.log(t('profile_updated_successfully'), response);
        // update user cookie
        setCookie('user', response, { path: '/' });
        setSuccess(t('profile_updated_successfully'));
        
        setTimeout(() => {
          setSuccess(null);
        }, 3000);
      });
  }

  return (
    <div className="edit-profile">
      <div className="row">

        <div className="col-xl-12">
          <form className="card" onSubmit={handleSubmit}>
            <div className="card-header">
              <h5 className="card-title">{t('edit_profile')}</h5>
            </div>
            <div className="card-body">
              <div className="row custom-input">
                <div className="col-xxl-6 box-col-12">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="Name">{t('name')}</label>
                    <input className="form-control" id="Name" type="text" placeholder={t('name')} onChange={(e) => setName(e.target.value)} value={name} readOnly={!!user.id} />
                  </div>
                </div>

                <div className="col-xxl-6 box-col-12">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="Email">{t('email')}</label>
                    <input className="form-control" id="Email" type="email" placeholder={t('email')} onChange={(e) => setEmail(e.target.value)} value={email} readOnly={!!user.id} />
                  </div>
                </div>

                {user?.estate_deliverer > 0 && (
                <div className="col-xxl-6 box-col-12">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="Emails">{t('invoice_emails')}</label>
                    <input className="form-control" id="Emails" type="text" placeholder={t('invoice_emails_comma_separated')} onChange={(e) => setEmails(e.target.value)} value={emails} />
                  </div>
                </div>
                )}

                <div className="col-xxl-6 box-col-12">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="Phone">{t('phone')}</label>
                    <input className="form-control" id="Phone" type="text" placeholder={t('phone')} onChange={(e) => setPhone(e.target.value)} value={phone} />
                  </div>
                </div>

                <div className="col-xxl-6 box-col-12">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="BankAccount">{t('bank_account')}</label>
                    <input className="form-control" id="BankAccount" type="text" placeholder={t('bank_account')} onChange={(e) => setBankAccount(e.target.value)} value={bankAccount} />
                  </div>
                </div>

                <div className="col-xxl-6 box-col-12">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="BankAccountName">{t('bank_account_name')}</label>
                    <input className="form-control" id="BankAccountName" type="text" placeholder={t('bank_account_name')} onChange={(e) => setBankAccountName(e.target.value)} value={bankAccountName} />
                  </div>
                </div>

                <div className="col-xxl-6 box-col-12">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="VatApplicable">{t('vat_applicable')}</label>
                    <select className="form-select" id="VatApplicable" value={vatApplicable ? "1" : "0"} onChange={(e) => setVatApplicable(e.target.value === "1")}>
                      <option value="1">{t('yes')}</option>
                      <option value="0">{t('no')}</option>
                    </select>
                  </div>
                </div>

                {vatApplicable && (
                <div className="col-xxl-6 box-col-12">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="Organisationsnummer">{t('org_personnummer')}</label>
                    <input className="form-control" id="Organisationsnummer" type="text" inputMode="numeric" pattern="[0-9 \-]*" placeholder={t('organisationsnummer_placeholder')} onChange={(e) => setOrganisationsnummer(e.target.value)} value={organisationsnummer} />
                    <small className="form-text text-muted">{t('organisationsnummer_helper')}</small>
                  </div>
                </div>
                )}

                <div className="col-xxl-6 box-col-12 d-flex align-items-center">
                  <div className="form-check form-switch">
                    <input className="form-check-input" id="interestedInMeatReturn" type="checkbox" role="switch" name="interested_in_meat_return" checked={interestedInMeatReturn} onChange={(e) => setInterestedInMeatReturn(e.target.checked)} />
                    <label className="form-check-label" htmlFor="interestedInMeatReturn">{t('interested_in_meat_return')}</label>
                  </div>
                </div>


                <div className="col-xxl-6 box-col-12">
                  <div className="form-check form-switch">
                    <input className="form-check-input" id="updatePassword" type="checkbox" role="switch" name="update_password" checked={updatePassword} onChange={(e) => setUpdatePassword(e.target.checked)} />
                    <label className="form-check-label" htmlFor="updatePassword">{t('update_password')}</label>
                  </div>
                </div>

                {updatePassword && (
                 <div className="row custom-input">
                <div className="col-xxl-6 box-col-12">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="Password">{t('password')}</label>
                    <input className="form-control" id="Password" type="password" placeholder={t('password')} onChange={(e) => setPassword(e.target.value)} value={password} />
                  </div>
                </div>

                <div className="col-xxl-6 box-col-12">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="PasswordRepeat">{t('repeat_password')}</label>
                    <input className="form-control" id="PasswordRepeat" type="password" placeholder={t('repeat_password')} onChange={(e) => setPasswordRepeat(e.target.value)} value={passwordRepeat} />
                  </div>
                </div></div>)}

              </div>
            </div>

            

            <div className="card-footer text-end">
              {error && <div className="alert alert-danger">{error}</div>}
              {success && <div className="alert alert-success">{success}</div>}
              <button className="btn btn-primary" type="submit">{t('update_profile')}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Element;
